import React, { useEffect, useRef } from 'react';
import { AppModal } from '../ModalSystem';
import { useI18n } from '../../i18n';

const ConfirmActionModal = ({
    isOpen,
    title,
    description,
    confirmLabel,
    cancelLabel,
    successLabel,
    loading = false,
    success = false,
    error = null,
    onConfirm,
    onCancel,
    confirmDisabled = false,
    renderAfterSuccess = null,
}) => {
    const { t } = useI18n();
    const finalConfirmLabel = confirmLabel || t('common.actions.confirm');
    const finalCancelLabel = cancelLabel || t('common.actions.cancel');
    const finalSuccessLabel = successLabel || t('common.actions.close');

    // Focus management is now handled by AppModal mostly, but we might need specific focus on buttons
    // However, AppModal traps focus. Standard behavior is usually sufficient.

    const handleConfirm = async () => {
        if (loading || confirmDisabled || !onConfirm) return;
        await onConfirm();
    };

    const footerButtons = (
        <>
            <button
                type="button"
                className={success ? "btn-primary" : "btn-secondary"}
                onClick={onCancel}
                disabled={loading}
            >
                {success ? finalSuccessLabel : finalCancelLabel}
            </button>
            {!success && (
                <button
                    type="button"
                    className="btn-danger"
                    onClick={handleConfirm}
                    disabled={loading || confirmDisabled}
                >
                    {loading ? `${finalConfirmLabel}...` : finalConfirmLabel}
                </button>
            )}
        </>
    );

    return (
        <AppModal
            isOpen={isOpen}
            onClose={() => !loading && onCancel()}
            title={title}
            size="sm"
            preventClose={loading}
            footer={footerButtons}
        >
            <div className="confirm-content">
                {!success && (
                    <p className="confirm-description">
                        {description}
                    </p>
                )}

                {success && (
                    <div className="confirm-success-state">
                        {renderAfterSuccess || (
                            <p>{t('common.status.success')}</p>
                        )}
                    </div>
                )}

                {error && !success && (
                    <div className="confirm-error-state">
                        {error}
                    </div>
                )}
            </div>
        </AppModal>
    );
};

export default ConfirmActionModal;
